import React, { useContext } from "react";
import { LanguageContext } from "../../../../constant/LanguageContext";

const PayrollStatsGrid = ({
  salaryStats,
  theme,
  spacing,
  fonts,
  screenSize,
  styles,
}) => {
  const isMobile = screenSize === "xs" || screenSize === "sm";
  const isTablet = screenSize === "md";

  const langContext = useContext(LanguageContext);
  const isRTL = langContext?.language === "ar" || document.dir === "rtl";

  return (
    <div
      className="stats-grid nx-kpi-grid"
      style={{
        display: "grid",
        gridTemplateColumns: isMobile
          ? "1fr"
          : isTablet
            ? "repeat(2, 1fr)"
            : "repeat(4, 1fr)",
        gap: isMobile ? "12px" : isTablet ? "16px" : "20px",
        marginBottom: spacing.margin,
        transition: "all 0.30s ease",
        direction: isRTL ? "rtl" : "ltr",
      }}
    >
      {salaryStats.map((stat, index) => (
        <div
          key={index}
          style={{
            background:
              theme === "dark"
                ? "rgba(255,255,255,0.01)"
                : "rgba(255,255,255,1)",
            padding: isMobile ? "16px" : isTablet ? "18px" : "20px",
            borderRadius: isMobile ? "12px" : "16px",
            transition: "all 0.3s ease",
            boxShadow:
              theme === "dark"
                ? "0 8px 32px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)"
                : "0 8px 32px rgba(0,0,0,0.1)",
            backdropFilter: theme === "dark" ? "blur(10px)" : "blur(0px)",
            WebkitBackdropFilter: theme === "dark" ? "blur(10px)" : "blur(0px)",
            border:
              theme === "dark"
                ? "1px solid rgba(255,255,255,0.15)"
                : "1px solid rgba(0,0,0,0.05)",
            cursor: "pointer",
            position: "relative",
            overflow: "hidden",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-4px)";
            e.currentTarget.style.boxShadow =
              theme === "dark"
                ? "0 12px 40px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.1)"
                : "0 12px 40px rgba(0,0,0,0.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow =
              theme === "dark"
                ? "0 8px 32px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)"
                : "0 8px 32px rgba(0,0,0,0.1)";
          }}
        >
          {/* Header with Icon and Label */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: isMobile ? "8px" : "12px",
              flexDirection: isMobile ? "column" : "row",
              textAlign: isMobile ? "center" : (isRTL ? "right" : "left"),
              gap: isMobile ? "8px" : "0",
            }}
          >
            {/* Icon Wrapper */}
            {stat.icon && (
              <div
                style={{
                  width: isMobile ? "36px" : "40px",
                  height: isMobile ? "36px" : "40px",
                  borderRadius: isMobile ? "6px" : "8px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#fff",
                  flexShrink: 0,
                  background: stat.color,
                  marginRight: isMobile ? "0" : (isRTL ? "0" : "12px"),
                  marginLeft: isMobile ? "0" : (isRTL ? "12px" : "0"),
                }}
              >
                <stat.icon size={isMobile ? 18 : 20} />
              </div>
            )}

            {/* Label */}
            <h4
              style={{
                marginLeft: isMobile ? "0" : (isRTL ? "0" : "12px"),
                marginRight: isMobile ? "0" : (isRTL ? "12px" : "0"),
                fontSize: isMobile ? "12px" : "14px",
                color:
                  theme === "dark"
                    ? "rgba(255,255,255,0.9)"
                    : "rgba(26,26,26,0.7)",
                fontWeight: "500",
                lineHeight: 1.3,
                margin: 0,
              }}
            >
              {stat.label}
            </h4>
          </div>

          {/* Value */}
          <p
            style={{
              fontSize: isMobile ? "20px" : isTablet ? "22px" : "24px",
              fontWeight: "700",
              color: theme === "dark" ? "#fff" : "#000",
              textAlign: isMobile ? "center" : (isRTL ? "right" : "left"),
              marginBottom: isMobile ? "4px" : "0",
              margin: 0,
            }}
          >
            {stat.value}
          </p>

          {/* Subtitle */}
          <p
            style={{
              fontSize: isMobile ? "12px" : "14px",
              color:
                theme === "dark"
                  ? "rgba(255,255,255,0.6)"
                  : "rgba(26,26,26,0.6)",
              margin: "8px 0 0 0",
              textAlign: isMobile ? "center" : (isRTL ? "right" : "left"),
            }}
          >
            {stat.subtitle}
          </p>
        </div>
      ))}
    </div>
  );
};

export default PayrollStatsGrid;